import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import './styles.css';

const RecommendCityCard = (props) => {
    const [city, setCity] = useState(null);

    const { name, country, pic } = props;

    const handleClick = () => {
        setCity(name);
    }

    if (city) {
        return <Redirect push to={`/details/${city}`} />;
    }

    return (
        <div className="box flex-item-main" onClick={handleClick}>
            <img src={pic} alt={`image of ${name}`} className="city-main" />
            <div className="direction">{`${name}, ${country}`}</div>
        </div>
    );
};

export default RecommendCityCard;
